/**
 * Handle layout javascript behavior
 */

window.app = window.app || {};

(function (layoutManager, $) {

    /**
     * Header DOM selector
     * @type {string}
     */
    var _headerSelector = 'header.header';

    /**
     * Initializes the behavior.
     */
    layoutManager.init = function () {
        _handleEvents();
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {
        $(window).on('scroll', function(e) {
            if ($(document).scrollTop() > 0) {
                $(_headerSelector).addClass('scrolled');
            } else {
                $(_headerSelector).removeClass('scrolled');
            }
        });

        $('.navbar-toggle').on('click', function() {
            $('header').toggleClass('show-menu');
        });

    };
})(
    window.app.layoutManager = window.app.layoutManager || {},
    jQuery
);
